import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../atoms/icon";

import styles from "./styles.m.css";

const CategoryBadge = ({ icon = "premium", color = "#2bab64", headline = "" }) => {
  return (
    <span className={`${styles["category"]}`} style={{ "--accent-color": color }}>
      <Icon className={styles["category-icon"]} type={icon} />
      <span className={styles["category-name"]}>{headline || null}</span>
    </span>
  );
};

CategoryBadge.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  headline: PropTypes.string
};

export { CategoryBadge };
